import chinookSchema from '../data/schemas/chinook';
import chartioSchema from '../data/schemas/chartio';
import chinookSql from '../data/sql/chinook-sql';
import DatasourceModel from '../models/datasource';
import {FEATURE_FLAGS, onFlagChange} from './feature_flags';

const chinookDataSource = new DatasourceModel(chinookSchema, chinookSql);
const chartioDataSource = new DatasourceModel(chartioSchema);

const DATASOURCES = {
    [chinookDataSource.name]: chinookDataSource,
};

function updateDatasources() {
    if (FEATURE_FLAGS.SHOW_CHARTIO_SOURCE) {
        DATASOURCES[chartioDataSource.name] = chartioDataSource;
    } else {
        delete DATASOURCES[chartioDataSource.name];
    }
}

onFlagChange('SHOW_CHARTIO_SOURCE', updateDatasources);

export default DATASOURCES;
